import { useState } from 'react';

import type { CategoryDto } from '@/api/types';
import CategoryBoxEdit from '@/features/categories/category-box/category-box-edit.tsx';
import CategoryBoxView from '@/features/categories/category-box/category-box-view.tsx';

type CategoryBoxProps = {
  projectId: string;
  category: CategoryDto;
};

const CategoryBox = ({ projectId, category }: CategoryBoxProps) => {
  const [editCategory, setEditCategory] = useState(false);

  return (
    <div className="flex items-center justify-between p-3 border rounded-lg hover:bg-muted/50 transition-colors">
      {editCategory ? (
        <CategoryBoxEdit
          projectId={projectId}
          category={category}
          onClose={() => setEditCategory(false)}
        />
      ) : (
        <CategoryBoxView
          projectId={projectId}
          category={category}
          onEditClick={() => setEditCategory(true)}
        />
      )}
    </div>
  );
};

export default CategoryBox;
